module.exports = __webpack_public_path__ + "static/img/norank-bg.f6345ac4.png";